import React from 'react';

import styled from '@emotion/styled';
import { Badge } from '@material-ui/core';

const TransientProps = ['transform'];

const getBaseTabStyles = (theme, props) => ({
  ' .MuiBadge-badge': {
    backgroundColor: theme.colors.alerts.negative,
    border: `0.5px solid ${theme.colors.common.white}`,
    userSelect: 'none',
    height: '16px',
    padding: '4px',
    borderRadius: '8px',
    // typography used is TextLabel with 600 weight
    // can't reuse the typography component so reusing its styling here
    fontSize: theme.customFontStyles.size.label,
    fontWeight: theme.customFontStyles.weight.bold,
    color: theme.colors.common.white,
    transform: props.transform,
  },
});

const StyledBadge = styled(Badge, {
  shouldForwardProp: (prop) => !TransientProps.includes(prop),
})(({ theme, ...props }) => ({
  ...getBaseTabStyles(theme, props),
}));

const NotificationBadge = ({ notificationCount = 0, anchorOrigin, transform, children }) => {
  if (!notificationCount) {
    return children;
  }
  return (
    <StyledBadge size="small" anchorOrigin={anchorOrigin} badgeContent={notificationCount} transform={transform}>
      {children}
    </StyledBadge>
  );
};

export { NotificationBadge };
